/**
 * 로그아웃 및 계정 전환 시 공통 cleanup 로직
 */

import { clearAllPendingAiSummaries } from '@/utils/aiAutoFill';
import { removeCookie } from '@/utils/tokens';
import { COOKIE_KEY_TOKEN_SET } from '@/constant/keys';

/**
 * 사용자 세션 정리
 * - 로그아웃 시
 * - 주 계정 변경 시
 * - 계정 전환 시
 */
export const cleanupUserSession = () => {
  // 1. 쿠키 삭제
  COOKIE_KEY_TOKEN_SET.forEach(removeCookie);

  // 2. pending AI 요약 정보 삭제
  clearAllPendingAiSummaries();

  // 추가적인 cleanup 로직이 필요하면 여기에 추가
};
